"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var notDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createNot: _factoriesAny.createNot
};
exports.notDependencies = notDependencies;